import {ValueObject} from '@s-ui/domain'

export class BuyerDataParamsRequest extends ValueObject {
  /**
   * @param {Object} data
   * @param {String} data.id
   * @param {String} data.residence
   * @param {String} data.lastName
   * @param {String} data.firstName
   * @param {String} data.mail
   **/

  static validate({id, lastName, firstName, residence, mail, validationError}) {
    const checkValidData = value => value !== null && value !== undefined && value !== ''
    if (!checkValidData(id)) throw validationError(`Invalid buyer id => ${id}`)
    if (!checkValidData(lastName)) throw validationError(`Invalid buyer lastName => ${lastName}`)
    if (!checkValidData(firstName)) throw validationError(`Invalid buyer firstName => ${firstName}`)
    if (!checkValidData(residence)) throw validationError(`Invalid buyer residence => ${residence}`)
    if (!checkValidData(mail)) throw validationError(`Invalid buyer mail => ${mail}`)
  }
}
